var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-question"},[_c('div',{staticClass:"common-question-text",on:{"click":_vm.jump}},[_vm._v(_vm._s(_vm.wenan))])])}
var staticRenderFns = []

export { render, staticRenderFns }